<script setup lang="ts">
import { useData } from '../../_composables/useData';
import ExpandableCard from '@components/util/ExpandableCard.vue';
import FaqList from '@components/util/faq/FaqList.vue';

const { hotelPackage } = useData();
const contentStore = useContentStore();
const { searchResultFaqs } = classToRefs(contentStore);

const items = computed(() => [
    ...(hotelPackage.value.faqs.map(faq => ({
        title: faq.question || '',
        value: faq.answer || '',
    })) || []),
    ...searchResultFaqs.value.map(faq => ({
        title: faq.question || '',
        value: faq.answer || '',
    })),
]);
</script>
<template>
    <div v-if="items.length" id="faq" class="faq-section">
        <mr-typography type="h2" size="x-large" weight="700" class="title">
            سؤالات متداول
        </mr-typography>
        <ExpandableCard
            :default-height="449"
            :data-value="hotelPackage.faqs.length"
        >
            <blockquote class="ma-0">
                <FaqList :items />
            </blockquote>
        </ExpandableCard>
    </div>
</template>
<style scoped lang="scss">
.faq-section {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1200px;
    margin-top: 32px;
    gap: 8px;
    @include mobile-only {
        margin-inline: 12px;
        padding-inline: 16px;
    }
    > .title {
        @include tg-xl($w7);
        margin-bottom: 8px;
        margin-top: 0;
        display: flex;
        gap: 20px;
        @include mobile-only {
            margin-bottom: 0;
        }
    }
    .ma-0 {
        margin: 0;
    }
}
</style>
